<template>
  <div>
    <div class="loading-state-container" v-if="loadProgramState && loadProgramState.status === 'loading'">
      <div class="container">
        <PreloaderSection />
      </div>
    </div>
    <Page v-if="loadProgramState && loadProgramState.status === 'success'">
      <ConfirmModal
        v-if="confirmModal"
        :onClose="handleConfirmModal"
        :onConfirm="onDelete">
        <template v-slot:header-title>
          <h4>ยืนยันการลบ</h4>
        </template>
        <div>คุณยืนยันที่จะลบ{{getProgramType()}} {{getProgramName()}}</div>
        <div class="warningDelete" v-if="checkProgramSeason()">รายการนี้เป็นรายการที่ออกอากาศเป็นซีซัน หากลบรายการนี้ ข้อมูลรายการซีซันที่เหลือจะถูกลบด้วย</div>
      </ConfirmModal>
      <template v-slot:page-header>
        <div class="container">
          <div class="page-header">
            <router-link
              class="btn btn-action btn-action-back"
              :to="`/programs`">
              <i class="fas fa-chevron-left" />
            </router-link>
            <div class="title-container">
              <div class="subtitle">แก้ไข{{getProgramType()}}</div>
              <!-- <div class="title">{{getProgramName()}}</div> -->
              <ul class="breadcrumb title">
                <li>
                  <router-link :to="`/programs/${getParent('id')}`">{{getParent('title')}}</router-link>
                </li>
                <li v-if="currentProgram.programType === 'season'" class="season">
                  <router-link :to="`/programs/${currentProgram.id}`">{{getProgramName()}}</router-link>
                </li>
              </ul>
            </div>
            <div class="actions">
              <small class="text-danger mr-3"
                v-if="getServerError()">
                {{getServerError()}}
              </small>
              <small class="text-success font-weight-bold mr-3" v-if="saveProgramState.status === 'saved'">
                <i class="fa fa-check" /> บันทึกแล้ว
              </small>
              <span v-if="isSaving">
                <i class="fa fa-spin fa-spinner mr-1" />
                <small class="mr-2">
                  กำลังบันทึก
                </small>
              </span>
              <button
                type="submit"
                class="btn btn-primary"
                :disabled="disableButton"
                @click.stop="onSubmit">
                บันทึก
              </button>
              <Dropdown :alignment="'right'">
                <template v-slot:dropdow-button>
                  <button
                    type="button"
                    class="btn btn-outline-dark btn-action m-0 ml-2">
                    <i class="fas fa-cog"></i>
                  </button>
                </template>
                <div class="dropdown-item" @click.stop="handleConfirmModal">
                  ลบ{{getProgramType()}}นี้
                </div>
              </Dropdown>
            </div>
          </div>
        </div>
      </template>
      <div class="container">
        <Tab>
          <div class="tab-item"
            v-for="(tabItem, tabIndex) in tabMenu"
            :key="tabIndex"
            :class="{'active': selectedTabIndex === tabIndex }"
            @click.stop="selectedTab(tabIndex)">
            {{tabItem.value}}
          </div>
        </Tab>
        <div class="tab-item tab-item-general"
          v-if="selectedTabIndex === 0">
          <div class="section-container">
            <SectionProgramGeneral />
          </div>
        </div>
        <div class="tab-item tab-item-information"
          v-if="selectedTabIndex === 1">
          <div class="section-container">
            <SectionProgramInformation />
          </div>
          <div class="section-container">
            <SectionProgramPerson />
          </div>
          <div class="section-container">
            <SectionProgramContact />
          </div>
          <div class="section-container">
            <SectionGallery />
          </div>
          <div class="section-container">
            <SectionAttachment />
          </div>
        </div>
        <div class="tab-item tab-item-general" v-if="selectedTabIndex === 2">
          <div class="section-container">
            <SectionContentImage
              @update:image="(payload) => $store.dispatch('setCurrentProgram', payload)"
              :item="currentProgram"
              :isProgram="true" />
          </div>
        </div>
        <div class="tab-item tab-item-playlist" v-if="selectedTabIndex === 3">
          <SectionProgramPlaylist />
        </div>
        <div class="tab-item tab-item-playlist" v-if="selectedTabIndex === 4">
          <SectionProgramActivityBanner />
        </div>
        <div class="tab-item tab-item-playlist" v-if="selectedTabIndex === 5">
          <SectionRelatedProgram />
        </div>
        <div class="tab-item tab-item-playlist" v-if="selectedTabIndex === 6">
          <SectionSeasons :goToFirstTab="goToFirstTab"/>
        </div>
      </div>
    </Page>
    <ErrorMessageProgramContainer
      v-if="loadProgramState && loadProgramState.status === 'error'"
      :error="loadProgramState.error"
      :redirectLink="'/programs'" />
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import dateFormetter from '@/utils/dateFormatter';
import errorFormatter from '@/utils/errorFormatter';
import ConfirmModal from '@/components/ConfirmModal.vue';
import Dropdown from '@/components/Dropdown.vue';
import Page from '@/layouts/Page.vue';
import Tab from '@/components/Tab.vue';
import PreloaderSection from '@/components/PreloaderSection.vue';

import SectionGallery from '@/gallery/SectionGallery.vue';
import SectionAttachment from '@/attachment/SectionAttachment.vue';
import SectionContentImage from '@/image/SectionContentImage.vue';

import SectionProgramGeneral from './SectionProgramGeneral.vue';
import SectionProgramInformation from './SectionProgramInformation.vue';
import SectionProgramPerson from './SectionProgramPerson.vue';
import SectionProgramContact from './SectionProgramContact.vue';
import SectionProgramPlaylist from './SectionProgramPlaylist.vue';
import SectionRelatedProgram from './SectionRelatedProgram.vue';
import SectionSeasons from './SectionSeasons.vue';
import SectionProgramActivityBanner from './SectionProgramActivityBanner.vue';
import ErrorMessageProgramContainer from './ErrorMessageProgramContainer.vue';

export default {
  mixins: [dateFormetter, errorFormatter],
  components: {
    Page,
    Tab,
    SectionProgramGeneral,
    SectionProgramInformation,
    SectionProgramPerson,
    SectionProgramContact,
    SectionGallery,
    SectionAttachment,
    Dropdown,
    ConfirmModal,
    SectionContentImage,
    PreloaderSection,
    ErrorMessageProgramContainer,
    SectionProgramPlaylist,
    SectionRelatedProgram,
    SectionSeasons,
    SectionProgramActivityBanner,
  },
  data() {
    return {
      tabMenu: [
        {
          key: 'general',
          value: 'ข้อมูลรายการ',
        },
        {
          key: 'information',
          value: 'รายละเอียด',
        },
        {
          key: 'contentImage',
          value: 'รูปปก/โลโก',
        },
        {
          key: 'playlist',
          value: 'เพลย์ลิสต์',
        },
        {
          key: 'banner',
          value: 'แบนเนอร์กิจกรรม',
        },
        {
          key: 'relatedProgram',
          value: 'รายการที่เกี่ยวข้อง',
        },
        {
          key: 'seasons',
          value: 'ซีซั่น',
        },
      ],
      selectedTabIndex: 0,
      oldProgramTitle: '',
      confirmModal: false,
    };
  },
  created() {
    this.load();
    this.oldProgramTitle = this.getProgramName();
  },
  computed: {
    ...mapState({
      currentProgram: (state) => state.programItem.currentProgram,
      seasons: (state) => state.programItem.seasons,
      loadProgramState: (state) => state.programItem.loadProgramState,
      saveProgramState: (state) => state.programItem.saveProgramState,
      attachment: (state) => state.attachment.attachment,
      currentGallery: (state) => state.gallery.currentGallery,
    }),
    programKey() {
      return this.$route.params.programKey;
    },
    haveErrorMessage() {
      return _.some(this.saveProgramState.error, (value) => value);
    },
    isSaving() {
      return this.saveProgramState.status === 'saving';
    },
    disableButton() {
      return this.haveErrorMessage || this.isSaving;
    },
  },
  watch: {
    $route() {
      this.$store.dispatch('loadProgramByKey', this.programKey);
    },
  },
  methods: {
    async load() {
      await this.$store.dispatch('destroyCurrentProgram');
      await this.$store.dispatch('loadProgramByKey', this.programKey);
      if (this.currentProgram.programType === 'season') {
        this.tabMenu[0].value = 'ข้อมูลซีซั่น';
      }
    },
    async onSubmit() {
      this.currentProgram.galleryId = this.currentGallery.id;
      await this.$store.dispatch('updateProgramByKey', { programId: this.programKey, payload: this.currentProgram });
      this.oldProgramTitle = this.getProgramName();
    },
    async onDelete() {
      const { parentProgramId, programType } = this.currentProgram;
      await this.$store.dispatch('deleteProgram', this.programKey);
      if (programType === 'season') {
        this.$router.push(`/programs/${parentProgramId}`);
      } else {
        this.$router.push('/programs');
      }
      this.confirmModal = !this.confirmModal;
    },
    handleConfirmModal() {
      this.confirmModal = !this.confirmModal;
    },
    selectedTab(selectedTabIndex) {
      this.selectedTabIndex = selectedTabIndex;
    },
    goToFirstTab() {
      this.selectedTabIndex = 0;
    },
    getServerError() {
      return _.get(this.saveProgramState, 'error.serverError', null);
    },
    getProgramName() {
      return _.get(this.currentProgram, 'title', this.programKey);
    },
    getParent(field) {
      return _.get(this.seasons[0], field);
    },
    checkProgramSeason() {
      if (this.currentProgram.programType === 'program' && this.currentProgram.hasSeason) {
        return true;
      }
      return false;
    },
    getProgramType() {
      if (this.currentProgram.programType === 'program') {
        return 'รายการ';
      }
      return 'ซีซั่น';
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/layouts/page.scss';
@import './src/assets/scss/themes/components/section-container.scss';

/* Style the list */
ul.breadcrumb {
  padding: 0px;
  list-style: none;
  background-color: rgba(255, 255, 255, 0);
}

/* Display list items side by side */
ul.breadcrumb li {
  display: flex;
  align-items: center;
}

/* Add a slash symbol (/) before/behind each list item */
ul.breadcrumb li+li:before {
  padding: 8px;
  color: black;
  content: "\003e";
}

/* Add a color to all links inside the list */
ul.breadcrumb li a {
  color: #000000;
  text-decoration: none;
}

/* Add a color on mouse-over */
ul.breadcrumb li a:hover {
  text-decoration: underline;
}

ul li.season {
  font-weight: 400;
}

.warningDelete {
  font-size: 12px;
  margin-top: 1rem;
}
</style>
